/// <amd-module name="Feed/Legacy/Protocols/Ivy/IvyOverviewContentPanel" />
import * as React from "react";

import { List } from "OfficeFabric/List";

import * as Utils_String from "VSS/Core/Util/String";

import * as Tooltip from "VSSUI/Tooltip";

import { CiConstants } from "Feed/Common/Constants/Constants";
import { IvyXmlInfo, IvyXmlModule } from "Feed/Common/Protocols/Ivy/Contracts/Ivy";
import * as PackageResources from "Feed/Common/Resources";
import { ConnectToFeedButton } from "Feed/Legacy/Components/ConnectToFeedButton";
import { ExternalLink } from "Feed/Legacy/Components/ExternalLink";
import { CustomerIntelligenceHelper } from "Feed/Legacy/Helpers/CustomerIntelligenceHelper";
import { IPackageDetailsProps } from "Feed/Legacy/Protocols/Common/IPackageDetailsProps";
import { IPackageProtocol } from "Feed/Legacy/Protocols/Common/IPackageProtocol";
import { CopyableTextField, ICopyableTextFieldTelemetry } from "Feed/Legacy/Protocols/Components/CopyableTextField";
import { PackageTile } from "Feed/Legacy/Protocols/Components/PackageTile";
import { IvyCiConstants } from "Feed/Legacy/Protocols/Ivy/Constants/IvyConstants";
import * as IvyFileHelper from "Feed/Legacy/Protocols/Ivy/IvyFileHelper";
import { HubAction } from "Feed/Legacy/Types/IHubState";

export class IvyOverviewContentPanel extends React.PureComponent<IPackageDetailsProps> {
    public render(): JSX.Element {
        const protocolMap: { [key: string]: IPackageProtocol } = {};
        protocolMap[this.props.protocol.name] = this.props.protocol;

        const module: IvyXmlModule =
            this.props.packageVersion.protocolMetadata && this.props.packageVersion.protocolMetadata.data
                ? (this.props.packageVersion.protocolMetadata.data as IvyXmlModule)
                : null;
        const info: IvyXmlInfo = this.props.packageVersion.isDeleted ? null : module && module.info;

        return (
            <div className="ivy-overview-content-panel package-overview-content-panel">
                {info ? (
                    <PackageTile title={PackageResources.Ivy_InstallInstructions_Title}>
                        <ConnectToFeedButton
                            pageContext={this.props.pageContext}
                            feed={this.props.feed}
                            feedViews={this.props.feedViews}
                            protocolMap={protocolMap}
                            hubAction={HubAction.Package}
                        />
                        <span className="install-instructions-then">{PackageResources.InstallInstructions_then}</span>
                        <CopyableTextField
                            pageContext={this.props.pageContext}
                            text={this._renderPackageAsDependencyText(info)}
                            buttonAriaLabel={PackageResources.AriaLabel_CopyToClipBoard_Ivy_DepencencyXML_Copy}
                            textFieldAriaLabel={PackageResources.AriaLabel_CopyToClipBoard_Ivy_DepencencyXML}
                            telemetryProperties={
                                {
                                    commandName: CiConstants.CopyCommandInstall,
                                    feedName: this.props.feed.name,
                                    packageName: this.props.packageSummary.name,
                                    packageVersion: this.props.packageVersion.version,
                                    protocol: this.props.protocol.name
                                } as ICopyableTextFieldTelemetry
                            }
                        />
                    </PackageTile>
                ) : (
                    <PackageTile title={""}>
                        <ConnectToFeedButton
                            pageContext={this.props.pageContext}
                            feed={this.props.feed}
                            feedViews={this.props.feedViews}
                            protocolMap={protocolMap}
                            hubAction={HubAction.Package}
                        />
                    </PackageTile>
                )}
                {this.props.packageVersion.description && this.props.packageVersion.description.length > 0 && (
                    <PackageTile title={PackageResources.Ivy_Description_Title}>
                        <div className="package-description">{this.props.packageVersion.description}</div>
                    </PackageTile>
                )}
                <PackageTile title={PackageResources.Ivy_Publications_Title}>
                    <List items={IvyFileHelper.getFiles(this.props.packageVersion)} onRenderCell={this._renderFile} />
                </PackageTile>
            </div>
        );
    }

    private _renderPackageAsDependencyText(info: IvyXmlInfo): string {
        return Utils_String.format(
            "<dependency\n" + ' org="{0}"\n' + ' name="{1}"\n' + ' rev="{2}" />',
            info.organisation,
            info.module,
            info.revision
        );
    }

    private _renderFile = (file: IvyFileHelper.IIvyFile): JSX.Element => {
        return (
            <Tooltip.TooltipHost content={file.name}>
                {this.props.packageVersion.isDeleted ? (
                    <label className="strike-through">{file.name}</label>
                ) : (
                    <ExternalLink
                        pageContext={this.props.pageContext}
                        href="#"
                        rel="noopener noreferrer"
                        ciContext={IvyCiConstants.Publications}
                        onClick={ev => {
                            ev.preventDefault();
                            IvyFileHelper.getHrefLink(
                                this.props.pageContext,
                                file.key,
                                this.props.feed.id,
                                this.props.packageSummary.normalizedName,
                                this.props.packageVersion.normalizedVersion,
                                (href: string) => {
                                    const newWindow = window.open(href, "_blank");
                                    if (newWindow) {
                                        newWindow.opener = undefined;
                                    }
                                }
                            );
                            CustomerIntelligenceHelper.publishEvent(
                                this.props.pageContext,
                                IvyCiConstants.PublicationAnchorClicked
                            );
                        }}
                    >
                        {file.name}
                        <span className="bowtie-icon bowtie-navigate-external" />
                    </ExternalLink>
                )}
            </Tooltip.TooltipHost>
        );
    };
}
